module.exports = __webpack_public_path__ + "static/media/magnifying_glass7122b9a19464046e6995083773071c1c.webp";